import polyglotI18nProvider from 'ra-i18n-polyglot';
import { TranslationMessages } from 'ra-core';
import raEn from 'ra-language-english';
import en from './locales/en.json';

const locales: Record<string, TranslationMessages> = {
  en: {
    ...raEn,
    ...en,
  },
};
type Locale = keyof typeof locales;

const DEFAULT_LOCALE = 'en';
const AVAILABLE_LOCALES: Locale[] | any = [{ locale: 'en', name: 'English' }];

export const i18nProvider = polyglotI18nProvider(
  (locale: string) => locales[locale as Locale],
  DEFAULT_LOCALE,
  AVAILABLE_LOCALES,
  { allowMissing: true }
);
